let resumeData = {
  "imagebaseurl": "https://derouineaunicolas.github.io/",
  "name": "Nicolas DEROUINEAU",
  "role": "Senior Software Engineer",
  "email": "nicodero72@gmail.com",
  "linkedinId": "https://www.linkedin.com/in/nicolas-derouineau-88a87b86/",
  "roleDescription": "Senior Software Engineer specialized in real-time multimedia architectures, low-level C++ systems, and modern full-stack web/cloud platforms.",
  "socialLinks": [
    {
      "name": "linkedin",
      "url": "https://www.linkedin.com/in/nicolas-derouineau-88a87b86/",
      "className": "fa fa-linkedin"
    },
    {
      "name": "github",
      "url": "https://github.com/DerouineauNicolas",
      "className": "fa fa-github"
    },
    {
      "name": "email",
      "url": "mailto:nicodero72@gmail.com",
      "className": "fa fa-envelope"
    }
  ],
  "address": "France (Remote / Europe)",
  "website": "https://derouineaunicolas.github.io",
  "skills": {
    "systems": [
      "C++17 / C",
      "POSIX Threads (pthreads)",
      "Audio DSP (FIR, FFT)",
      "Linux ALSA API",
      "Android / Kotlin",
      "Low-Latency Architecture"
    ],
    "streaming": [
      "MPEG-DASH & HLS",
      "FFmpeg C API & CLI",
      "MP4Box",
      "Web Audio API",
      "WebGL / GLSL Shaders",
      "Video Transcoding"
    ],
    "web": [
      "Python / Django / DRF",
      "JavaScript / TypeScript",
      "React.js",
      "Node.js / Express",
      "Socket.io / WebSockets",
      "RESTful APIs"
    ],
    "devops": [
      "Docker & Containerization",
      "Linux / Debian / Ubuntu",
      "CI / CD (GitHub Actions)",
      "Git & GitFlow",
      "Nginx",
      "Linux Networking"
    ]
  }
};

export default resumeData;
